$(document).ready(function() {

    function general(){

        $('.expand-announcement-btn').on('click', function(){
            $('.expanded-announcement').toggleClass('active');
        });

        $('.close-expand-announcement').on('click', function(){
            $('.expanded-announcement').removeClass('active');
        });

        function removeAnnouncement(){
            $('#announcement-bar').addClass('hide').fadeOut(300);
            $('body').removeClass('has-announcement');
            localStorage.setCacheItem("HH-signup-cache-1", "closed", { days: 1 }); 
        }

        var announcementFlag = localStorage.getCacheItem("HH-signup-cache-1");
        if(!announcementFlag ){
            // $('#signup-newsletter, #signup-newsletter-overlay').removeClass('hide').fadeIn(300);
            var header = $('#global-header').outerHeight(true),
                barheight = $('#announcement-bar').outerHeight(true),
                mainmenuheight = $('.sub-nav.header-2020').outerHeight(true);

            $('body').css('padding-top', header + barheight + mainmenuheight);
            $('#global-header').css('top', barheight);
            $('.expanded-announcement').css('top', barheight);
            $('.sub-nav.header-2020').css('top', header + barheight);

            console.log('loaded, not closed');
        } else {
            // $('#signup-newsletter, #signup-newsletter-overlay').removeClass('hide');
            removeAnnouncement();
        }

        $('#announcement-close').bind('click', function(){
            removeAnnouncement();
        });
    }

    $(window).ready(function(){
        general();
    });


    $(window).resize(function(){
       general();
    });

});